import React, { Component } from 'react';
import moment from 'moment';
import http from 'utils/http';
import API from 'utils/API';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';

interface IInterestStates {
    error: Error | null;
    isLoading: boolean;
    data: any;
}

class Interest extends Component<{}, IInterestStates> {
    readonly state = {
        isLoading: true
    } as IInterestStates;

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        this.setState({
            isLoading: true,
            error: null
        });

        try {
            const params = { license: 'Marsco' };
            const resp = await http.get(API.CUSTOMER.getRates(), {
                params
            });

            this.setState({
                data: resp.data
            });
        } catch (error) {
            this.setState({
                error
            });
        }

        this.setState({
            isLoading: false
        });
    };

    render() {
        const { isLoading, error, data } = this.state;

        if (error) {
            return <ErrorBox error={error} onClick={this.getData} />;
        }

        if (isLoading) {
            return <Loading />;
        }

        const showHK = !!(data && data?.base_rates?.length && data?.pay_rates?.length);

        return (
            <div className="page-pricing-interest">
                <h3 className="title">US Stocks</h3>
                <p className="interest-desc">
                    TradeUP Securities, Inc.’ benchmark for each currency is the reference rate around which our credit,
                    debit, stock-loan, and other interest rate linked calculations are determined. TradeUP Securities,
                    Inc. uses a combination of internationally recognized interest rate fixings (such as LIBOR, Fed
                    Funds, etc) and dynamic interbank rates determined from foreign exchange and money-markets to
                    calculate a TradeUP Securities, Inc. Reference Benchmark rate.
                </p>
                {/* 数据部分由于 CHN 和 HKD 暂不支持，所以这里暂时隐藏相关内容，只展示 USD 部分 */}
                {showHK && (
                    <>
                        <div className="pricing-table-wrap">
                            <table className="pricing-table">
                                <thead>
                                    <tr>
                                        <th>Currency</th>
                                        <th>Description </th>
                                        <th>Rate</th>
                                        <th>Effective Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{data.base_rates[0].currency}</td>
                                        <td>Reference Benchmark {data.base_rates[0].currency}</td>
                                        <td>{data.base_rates[0].rate}</td>
                                        <td>{moment(data.base_rates[0].date).format('ll')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p className="tip">
                            <strong>BM = Benchmark Rate</strong>
                        </p>

                        <div className="pricing-table-wrap">
                            <table className="pricing-table">
                                <thead>
                                    <tr>
                                        <th>Currency</th>
                                        <th>Loan Amount</th>
                                        <th>Rate Paid</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.pay_rates[0].data.map((value, i) => (
                                        <tr key={`item${i}`}>
                                            {i === 0 && (
                                                <td rowSpan={data.pay_rates[0].data.length}>
                                                    {data.pay_rates[0].currency}
                                                </td>
                                            )}
                                            <td>{value.range}</td>
                                            <td>{value.rate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <h3 className="title">HK Stocks</h3>
                        <div className="pricing-table-wrap">
                            <table className="pricing-table">
                                <thead>
                                    <tr>
                                        <th>Currency</th>
                                        <th>Loan Amount</th>
                                        <th>Rate Paid</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.pay_rates[2].data.map((value, i) => (
                                        <tr key={`item${i}`}>
                                            {i === 0 && (
                                                <td rowSpan={data.pay_rates[2].data.length}>
                                                    {data.pay_rates[2].currency}
                                                </td>
                                            )}
                                            <td>{value.range}</td>
                                            <td>{value.rate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <p className="tip">
                            <strong>BM = Benchmark Rate</strong>
                        </p>

                        <p className="interest-desc">
                            * The fee for exchanging between USD and HKD is $2.00 per execution. For HKD-USD exchanges
                            greater than USD 100,000, the fee is 2/100,000 of the total exchange amount. The maximum
                            exchange amount may not exceed USD 7,000,000 or HKD 50,000,000.
                        </p>
                    </>
                )}
            </div>
        );
    }
}

export default Interest;
